import React, { useMemo } from 'react';
import { Table } from '../../../components/ui';
import EditDailyLimitCell from './components/EditDailyLimitCell';
import EditIPPoolCell from './components/EditIPPoolCell';
import MoveToWarmupButton from './components/MoveToWarmupButton';
import DeleteDomainButton from './components/DeleteDomainButton';

export default function PreWarmedUpDomain({ domains }) {
  const columns = useMemo(() => {
    return [
      {
        title: 'Domain',
        dataIndex: 'name',
        key: 'name',
      },
      {
        title: 'IP Pool Name',
        align: 'center',
        dataIndex: 'ipPool',
        key: 'ipPool',
        render: (value, row) => {
          return <EditIPPoolCell domain={row} key={row.ipPool} />;
        },
      },
      {
        title: 'Daily Usage / Daily Limit',
        dataIndex: 'dailyLimit',
        align: 'center',
        render: (value, row) => {
          return <EditDailyLimitCell domain={row} key={row.dailyLimit} />;
        },
      },
      {
        key: 'actions',
        align: 'center',
        render: (value, row) => {
          return (
            <div
              className="flex items-center space-x-2"
              style={{ justifyContent: 'center' }}
            >
              <MoveToWarmupButton domain={row} />
              <DeleteDomainButton domain={row} />
            </div>
          );
        },
      },
    ];
  }, []);
  return (
    <Table
      columns={columns}
      dataSource={domains || []}
      pagination={false}
      rowKey="name"
    />
  );
}
